module.exports = __webpack_public_path__ + "img/file-lock.6012f7fb.svg";